/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
// eslint-disable-next-line no-unused-vars
// import slickcss from 'slick-carousel/slick/slick.css';
import WithElectionBannerLoadable from 'components/ElectionBanner/WithElectionBannerLoadable';
import { getBannerData, convertToKebabCase } from 'utils/common';
import { getMobileScrollManager, getDesktopScrollManager } from 'components_v2/common/ScrollEventManager/optimizedScrollHandler';
import { getPosition } from 'utils/DOMUtils';
import ImageV2 from 'components_v2/common/ImageV2';
import LoadableComponentLoader from 'components_v2/common/LoadableComponentLoader/LoadableComponentLoader';
import { TOI_IMAGE_DOMAIN } from 'constants/index';
import s from './LeadImageOrVideo.scss';
import ArticleLeadCaption from '../ArticleLeadCaption/ArticleLeadCaption';

class LeadImageOrVideo extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      videoActive: false,
      isClientSide: false,
      leadVideoIsDocked: false,
    };
    this.myRef = React.createRef();
    // this.handleImageView = this.handleImageView.bind(this);
    this.oldFlag = false;
  }

  componentDidMount() {
    const { video, loadVideoTheatreSlider, isWapView } = this.props;
    if (loadVideoTheatreSlider && video.id) {
      this.props.loadVideoTheatreSlider(video.wu, this.props.isWapView);
    }
    if (typeof window !== 'undefined') {
      this.setState({
        isClientSide: true,
      });
      this.observer = new IntersectionObserver(
        ([entry]) => {
          const isInViewport = !entry.isIntersecting;
          this.setState({ isInViewport });
          // Call the callback if provided
          if (this.props.onVisibilityChange) {
            this.props.onVisibilityChange(this.state.isInViewport);
          }
        },
        {
          threshold: [1], // Trigger at 0% and 100% visibility
          rootMargin: '-10px', // Add a small margin to prevent flickering
        },
      );
      if (this.myRef.current) {
        this.observer.observe(this.myRef.current);
      }

      // Initialize optimized scroll handling
      this.initializeOptimizedScrollHandler(isWapView);
    }
  }

  initializeOptimizedScrollHandler = (isWapView) => {
    // Get the appropriate scroll manager based on device
    this.scrollManager = isWapView ? getMobileScrollManager() : getDesktopScrollManager();
    this.scrollManager.init();
    
    // Register moderate handler for image visibility tracking
    this.mHandlerId = this.scrollManager.registerModerateHandler(this.handleImageViewOptimized,{},'leadimage-visibility');
  };

  handleImageViewOptimized = (scrollData) => {
    if (!this.myRef.current) return;
    
    const { scrollTop, windowHeight } = scrollData;
    const pos = windowHeight - (getPosition(this.myRef.current).y - scrollTop);
    let flag = false;
    
    if (pos >= this.props.bottom) {
      flag = true;
    } else {
      flag = false;
    }
    
    if (this.oldFlag !== flag && typeof this.props.cb === 'function') {
      this.props.cb(flag);
      this.oldFlag = flag;
    }
  };

  componentWillUnmount() {
    // Clean up optimized scroll handler
    if (this.scrollManager) {
      this.scrollManager.unregisterModerateHandler(this.mHandlerId );
    }

    // Clean up intersection observer
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  onVideoComnponentLoadOrUnload = (status = false) => {
    //alert('onVideoComnponentLoadOrUnload' + status);
    this.setState({
      videoActive: status,
    });
  };

  videoPlayCallback = status => {
    this.onVideoComnponentLoadOrUnload(status);
  };

  leadVideoIsDockedCallback = status => {
    this.setState({ leadVideoIsDocked: status });
  };

  getImageName = () => {
    if (this.props.image.name) {
      return convertToKebabCase(this.props.image.name);
    }
    if (this.props.image.nameseo) {
      return this.props.image.nameseo;
    }
    return this.props.image.id;
  };

  render() {
    const ss = this.props.styleObj;
    const {
      image,
      videoCaption,
      widgets,
      imgList,
      imageAlt,
      preloadedLeadImageHref,
      syn,
      isMspArticle,
      hl,
      isSPOTLIGHTArticle,
      isAutoPublishedArticle,
      videoThumbnailImage,
    } = this.props;
    const wdtData =
      widgets && widgets instanceof Array && widgets.length > 0
        ? getBannerData(widgets)
        : undefined;

    const resizemode = isAutoPublishedArticle && !isSPOTLIGHTArticle ? 72 : 4;
    const height =
      isAutoPublishedArticle && !isSPOTLIGHTArticle ? 'height-225,' : '';
    const settings = {
      slidesToShow: 1,
      slidesToScroll: 1,
      pauseOnHover: false,
      pauseOnFocus: false,
      dots: true,
      arrows: false,
      swipeToSlide: true,
      autoplay: true,
      draggable: false,
      infinite: true,
      dotsClass: s.dots,
      responsive: [
        {
          breakpoint: 999,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
          },
        },
      ],
    };

    let videoThumbnailUrl = '';
    if (this.props.video.id && videoThumbnailImage) {
      videoThumbnailUrl = `${TOI_IMAGE_DOMAIN}/thumb/msid-${
        videoThumbnailImage.id
      }${
        videoThumbnailImage.imagesize
          ? `,imgsize-${videoThumbnailImage.imagesize}`
          : ''
      },width-400,${height}resizemode-${resizemode}/${
        videoThumbnailImage.id
      }.jpg`;
    }

    const playerContainerId = `playerContainer_${this.props.video.id}`;
    const getComponentData = (
      <div className={s.dockWrap}>
        {this.props.video.id && (
          <div className={s.mainImg}>
            <ImageV2
              src={
                videoThumbnailUrl ||
                `https://static.toiimg.com/thumb/msid-${this.props.video.id ||
                  this.props
                    .videoImageId},width-400,${height}resizemode-${resizemode}/${this
                  .props.video.id || this.props.videoImageId}.jpg`
              }
              altTitle={this.props.video.hl ? this.props.video.hl : ''}
              title={this.props.video.hl ? this.props.video.hl : ''}
              className={`${s.leadVideoBg}`}
            />
          </div>
        )}
        <section
          className={`${s.leadmedia}  clearfix id-r-component leadmedia ${
            this.props.sClassName
          } ${s[this.props.className]} ${
            this.state.videoActive &&
            !this.props.isWapView &&
            !this.props.frmNic
              ? 'vdoactive'
              : ''
          } ${!this.props.video.id ? s.unDock : ''}`}
          ref={this.myRef}
          style={!this.state.leadVideoIsDocked ? { top: '0px' } : {}}
        >
          {Array.isArray(imgList) &&
            imgList.length > 0 && (
              <div className={`${s.stateContainer} as_alider `}>
                <Slider
                  ref={slider => {
                    this.slider = slider;
                  }}
                  {...settings}
                >
                  {imgList.filter((v, i) => i < 6).map(item => (
                    <>
                      <div
                        className={`resp_container ${
                          !item.cap ? 'no_Caption' : ''
                        }`}
                      >
                        <div className="img_wrapper">
                          {item.id &&
                            (item.id === '93166496' ||
                              item.id === '101017261') && (
                              <img
                                src={`https://static.toiimg.com/thumb/msid-${
                                  item.id
                                }${
                                  item.imagesize
                                    ? `,imgsize-${item.imagesize}`
                                    : ''
                                },width-838,resizemode-${resizemode}/${
                                  item.id
                                }.jpg`}
                                alt={hl}
                                title={item.cap}
                                decoding="async"
                              />
                            )}
                          {item.id &&
                            item.id !== '93166496' &&
                            item.id !== '101017261' && (
                              <img
                                src={`https://static.toiimg.com/thumb/msid-${
                                  item.id
                                }${
                                  item.imagesize
                                    ? `,imgsize-${item.imagesize}`
                                    : ''
                                },width-400,${height}resizemode-${resizemode}/${
                                  item.nameseo ? item.nameseo : item.id
                                }.jpg`}
                                alt={hl}
                                title={item.cap}
                                decoding="async"
                              />
                            )}
                        </div>
                      </div>
                      {item.cap && (
                        <ArticleLeadCaption
                          imgCaption={isMspArticle ? syn : item.cap}
                          styleObj={s}
                          isWapView={this.props.isWapView}
                          isMspArticle={isMspArticle}
                        />
                      )}
                    </>
                  ))}
                </Slider>
              </div>
            )}
          {!imgList &&
            this.props.image &&
            this.props.image.id && (
              <div
                className={s.leadmedia}
                data-ua-type="1"
                data-sp-pd-click="stpPgtnAndPrvntDefault(event)"
                onClick={event => {
                  window.stpPgtnAndPrvntDefault(event);
                }}
              >
                <div className={s.img_wrapper}>
                  <div className={s.content}>
                    {this.props.isExplainerArticle && (
                      <i
                        className={`${s.explainerstamp} ${this.props
                          .isWapView && s.small}`}
                      />
                    )}
                    {isSPOTLIGHTArticle && (
                      <img
                        src={
                          preloadedLeadImageHref ||
                          `https://static.toiimg.com/thumb/msid-${
                            this.props.image.id
                          }${
                            this.props.image.imagesize
                              ? `,imgsize-${this.props.image.imagesize}`
                              : ''
                          },width-838,resizemode-${resizemode}/${
                            this.props.image.id
                          }.jpg`
                        }
                        alt={hl || imageAlt || 'banner img'}
                        title={image.cap}
                        decoding="async"
                        // eslint-disable-next-line react/no-unknown-property
                        fetchpriority="high"
                      />
                    )}
                    {!isSPOTLIGHTArticle && (
                      <img
                        src={
                          preloadedLeadImageHref ||
                          `https://static.toiimg.com/thumb/msid-${
                            this.props.image.id
                          }${
                            this.props.image.imagesize
                              ? `,imgsize-${this.props.image.imagesize}`
                              : ''
                          },width-400,${height}resizemode-${resizemode}/${this.getImageName()}.jpg`
                        }
                        alt={hl || imageAlt || 'banner img'}
                        title={image.cap}
                        decoding="async"
                        // eslint-disable-next-line react/no-unknown-property
                        fetchpriority="high"
                      />
                    )}
                  </div>
                </div>
              </div>
            )}
          {!imgList &&
            this.props.video &&
            this.props.video.id && (
              //this.props.isWapView && (
              <>
                <LoadableComponentLoader
                  loadInView
                  loadableComponentName="VideoWidget"
                  activeMsid={this.props.activeMsid}
                  artilceMsid={this.props.artilceMsid}
                  autoPlay={
                    !!(
                      (!this.props.isWapView || this.props.enableAutoPlay) &&
                      //!this.props.loadedMiniTvComponent &&
                      !this.props.isPerpetual
                    )
                  }
                  isMute={
                    !!(!this.props.isWapView || this.props.enableAutoPlay) //&&
                    // !this.props.loadedMiniTvComponent
                  }
                  //videoActive={!this.props.isWapView}
                  video={this.props.video}
                  isLeadVideo
                  notitle
                  styleObj={s}
                  isUserPrime={this.props.isUserPrime}
                  iconClassName={s.playicon}
                  imageClassName={`${s.content}`}
                  videoClassName={`${s.content}`}
                  theatreModeClassName={s.leadvid_theatre_open}
                  isWapView={this.props.isWapView}
                  videoImageId={this.props.videoImageId}
                  videoPlayCallback={this.videoPlayCallback}
                  playerContainerId={playerContainerId}
                  videoTheatreSliderData={this.props.videoTheatreSliderData}
                  addNextVideoMsid={this.props.addNextVideoMsid}
                  dataFirstPlayClickGa={`ATF_lead_video|video-lead-user_initiated|msid_${
                    this.props.artilceMsid
                  }-video_${
                    this.props.video && this.props.video.id
                      ? this.props.video.id
                      : ''
                  }`}
                  dataSetGaCategory
                  dataCloseClickGa={`video-lead-close_video|msid_${
                    this.props.artilceMsid
                  }-video_${
                    this.props.video && this.props.video.id
                      ? this.props.video.id
                      : ''
                  }`}
                  isArticleshow={this.props.isArticleshow}
                  showMiniTvPlayer={this.props.showMiniTvPlayer}
                  enableDocking={this.props.enableDocking}
                  enableAutoPlay={this.props.enableAutoPlay}
                  leadVideoIsDockedCallback={this.leadVideoIsDockedCallback}
                  isV4DockingEnabled={this.props.isV4DockingEnabled}
                  isEtimes={this.props.isEtimes}
                />
              </>
            )}
          {!imgList && (
            <ArticleLeadCaption
              imgCaption={isMspArticle ? syn : image.cap}
              styleObj={s}
              videoCaption={videoCaption}
              isWapView={this.props.isWapView}
              isMspArticle={isMspArticle}
            />
          )}

          {!this.props.isWapView &&
            this.state.isClientSide &&
            wdtData && (
              <WithElectionBannerLoadable
                wdtData={wdtData}
                wrapperClassName="elec_banner"
              />
            )}
        </section>
      </div>
    );

    return (
      <>
        {this.props.isWapView && (
          <>
            <div id={`leadSentinal_${this.props.video.id}`} />
            <div
              className={`
                  ${ss.leadWrapper} 
                  ${this.props.isEtimesArticle ? ss.etimesLeadWrapper : ''} 
                  ${this.state.leadVideoIsDocked ? 'docklead' : ''}
                `}
              >
                {getComponentData}
              </div>
            </>
          )}
          {!this.props.isWapView && <> {getComponentData} </>}
        </>
      );
    }
  }

  LeadImageOrVideo.propTypes = {
    image: PropTypes.shape({
      imagesize: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      cap: PropTypes.string,
    }),
    imageAlt: PropTypes.string,
    video: PropTypes.shape({
      id: PropTypes.string.isRequired,
      h1: PropTypes.string.isRequired,
      playerId: PropTypes.string.isRequired,
      imageid: PropTypes.string.isRequired,
      payload: PropTypes.string.isRequired,
    }),
    sClassName: PropTypes.string.isRequired,
    styleObj: PropTypes.shape({}).isRequired,
    videoCaption: PropTypes.string,
    isWapView: PropTypes.bool,
    videoImageId: PropTypes.string.isRequired,
    loadVideoTheatreSlider: PropTypes.func,
    frmNic: PropTypes.bool,
    isUserPrime: PropTypes.bool,
    videoTheatreSliderData: PropTypes.arrayOf({}),
    addNextVideoMsid: PropTypes.func.isRequired,
    artilceMsid: PropTypes.string,
    isArticleshow: PropTypes.bool,
    widgets: PropTypes.shape({}),
    cb: PropTypes.func.isRequired,
    bottom: PropTypes.number,
    isExplainerArticle: PropTypes.bool,
    preloadedLeadImageHref: PropTypes.string,
    syn: PropTypes.string,
    isMspArticle: PropTypes.bool,
    isEtimesArticle: PropTypes.bool,
    showMiniTvPlayer: PropTypes.func,
    isSPOTLIGHTArticle: PropTypes.bool,
    onVisibilityChange: PropTypes.func,
  };

  LeadImageOrVideo.defaultProps = {
    image: {},
    imageAlt: undefined,
    video: {},
    videoCaption: '',
    isWapView: false,
    loadVideoTheatreSlider: undefined,
    frmNic: false,
    isUserPrime: false,
    videoTheatreSliderData: undefined,
    artilceMsid: '',
    isArticleshow: false,
    widgets: undefined,
    bottom: undefined,
    isExplainerArticle: false,
    preloadedLeadImageHref: '',
    syn: '',
    isMspArticle: false,
    isSPOTLIGHTArticle: false,
    isEtimesArticle: false,
    showMiniTvPlayer: undefined,
    onVisibilityChange: undefined,
  };

  export default LeadImageOrVideo;